import { render, staticRenderFns } from "./TaskManager.vue?vue&type=template&id=3424ab2b&scoped=true"
import script from "./TaskManager.vue?vue&type=script&lang=js"
export * from "./TaskManager.vue?vue&type=script&lang=js"
import style0 from "./TaskManager.vue?vue&type=style&index=0&id=3424ab2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3424ab2b",
  null
  
)

export default component.exports